(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'react-icon-base'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-icon-base'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactIconBase);
    global.Wantedly = mod.exports;
  }
})(this, function (exports, _react, _reactIconBase) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var FaAmazon = function (_React$Component) {
    _inherits(FaAmazon, _React$Component);

    function FaAmazon() {
      _classCallCheck(this, FaAmazon);

      return _possibleConstructorReturn(this, (FaAmazon.__proto__ || Object.getPrototypeOf(FaAmazon)).apply(this, arguments));
    }

    _createClass(FaAmazon, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          _reactIconBase2.default,
          _extends({ viewBox: '0 0 40 40' }, this.props),
          _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: ' M 0.00 6.99 C 2.08 7.00 4.16 7.00 6.24 7.00 C 8.95 13.39 11.50 19.84 14.22 26.22 C 15.11 24.13 15.96 22.03 16.82 19.92 C 15.13 15.59 13.28 11.32 11.55 7.01 C 13.64 7.00 15.74 6.99 17.83 7.00 C 18.55 8.73 19.28 10.46 20.00 12.19 C 20.72 10.46 21.45 8.74 22.17 7.01 C 24.26 6.99 26.36 7.00 28.45 7.01 C 26.72 11.32 24.87 15.59 23.18 19.92 C 24.04 22.03 24.89 24.14 25.79 26.23 C 28.51 19.83 31.02 13.34 33.81 6.96 C 35.88 6.99 37.94 7.02 40.00 7.03 L 40.00 7.27 C 36.19 16.13 32.64 25.11 28.89 34.00 C 26.77 34.05 24.65 34.00 22.53 33.88 C 21.75 31.75 20.89 29.66 20.00 27.59 C 19.11 29.67 18.25 31.77 17.46 33.89 C 15.34 34.00 13.22 34.05 11.10 34.00 C 7.37 25.07 3.73 16.09 0.00 7.16 L 0.00 6.99 Z' })
          )
        );
      }
    }]);

    return FaAmazon;
  }(_react2.default.Component);

  exports.default = FaAmazon;
});